import { MapPin, Car, Users, CalendarCheck } from "lucide-react";
import { praktisch } from "../../data/content";

const icons = [MapPin, Car, Users, CalendarCheck];

export const Praktisch = () => {
  return (
    <section data-testid="praktisch-section" className="py-16 md:py-24 bg-accent/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <span className="text-primary font-semibold text-sm uppercase tracking-wide">Praktische informatie</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mt-3">
            Goed om te weten
          </h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">{praktisch.intro}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {praktisch.punten.map((p, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div key={i} data-testid={`praktisch-${i}`} className="bg-background border border-border rounded-2xl p-6">
                <Icon size={24} className="text-primary mb-3" />
                <h3 className="font-heading text-lg font-semibold">{p.titel}</h3>
                <p className="mt-2 text-muted-foreground leading-relaxed">{p.tekst}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
